<template>
  <div class="flex items-center justify-end gap-[16px] sticky bottom-0 bg-white p-[16px]">
    <p class="text-[#F95031] mb-0">
      <span class="font-semibold">{{ selectedSize }}</span> Order terpilih
    </p>
    <b-button
      variant="primary"
      class="!py-[8px] !px-[14px]"
      :disabled="selectedSize <= 0 || isSubmittingOrder"
      @click="$emit('click')"
    >
      <b-spinner
        v-if="isSubmittingOrder"
        variant="light"
        small
      />
      <span>
        {{ label }}
      </span>
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'OrderAction',
  props: {
    isSubmittingOrder: {
      type: Boolean,
      required: false,
      default: false,
    },
    status: {
      type: String,
      required: false,
      default: 'submitted',
    },
    selectedSize: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      selectedOrder: new Set(),
    }
  },
  computed: {
    label() {
      if (this.status === 'submitted') {
        return 'Packing Produk'
      }
      if (this.status === 'confirmed') {
        return 'Order Terkirim'
      }

      return 'Unknown'
    },
  },
  methods: {
    setSelectedSize(size) {
      this.selectedSize = size
    },
  },
}
</script>
